import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';
import StyledCircularProgress from './Loading/StyledCircularProgress';

const classes = {
  root: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    gap: '18px',
    height: '22%',
    flexShrink: 0,
  },
  icnWrap: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '2%',
  },
  captionstyle: {
    color: 'greys.darker',
    textAlign: 'center',
    width: '100%',
  },
  captionWithValue: {
    flex: '1 1 30%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    minWidth: 0,
  },
};

const colors = ['primary.main', 'success.light', 'graphs.purple'];

const mapCounters = (countersData, intl) => {
  return Object.keys(countersData).map((keyName, index) => {
    if (Array.isArray(countersData[keyName]))
      return (
        <StyledCircularProgress
          key={keyName}
          progressData={{
            value: countersData[keyName][0] ?? 0,
            total: countersData[keyName][1] ?? 0,
          }}
          label={intl.messages[keyName]}
          color={colors[index]}
          size="90px"
        />
      );

    return (
      <div key={keyName} style={classes.captionWithValue}>
        <Typography variant="caption" sx={classes.captionstyle} noWrap>
          {intl.messages[keyName]}
        </Typography>
        <Typography sx={{ fontSize: '1.5rem', color: colors[index] }}>
          {countersData[keyName] || 0}
        </Typography>
      </div>
    );
  });
};

const Counters = function Counters({ data = {} }) {
  const intl = useIntl();

  return <div style={classes.root}>{mapCounters(data, intl)}</div>;
};

Counters.propTypes = {
  data: PropTypes.object,
};

export default Counters;
